import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { WorkProgressMaterialItem } from '../../interfaces/work-progress-material.interface';

@Component({
  selector: 'app-client-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="truncate">
      <span class="block truncate font-bold text-[10px]">{{ clientCode }}</span>
      <span class="block truncate text-xs">{{ clientName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientCellRendererComponent implements CellRenderer<WorkProgressMaterialItem> {
  @Input() params!: CellRendererParams<WorkProgressMaterialItem>;

  get clientCode(): string {
    return this.params?.data?.clientCode || '-';
  }

  get clientName(): string {
    return this.params?.data?.clientName || '';
  }
}
